import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProgramPricingInfo from "./ProgramPricingInfo";

function Menadzment() {
  const [t] = useTranslation();

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Menadžment" />
      <section className="project-detail">
        <div className="container">
          <div className="lower-content">
            <div className="row">
              <div className="text-column col-lg-9 col-md-9 col-sm-12">
                <h2>{t("osnovnem.title")}</h2>
                <div className="upper-box">
                  <div className="single-item-carousel owl-carousel owl-theme">
                    <figure className="image">
                      <img
                        src="assets/img/bg/Fpep-02.png"
                        alt="Menadžment slika"
                      />
                    </figure>
                  </div>
                </div>
                <div className="inner-column textjustify">
                  <h3>{t("programi.subtitle1")}</h3>
                  <p>{t("osnovnem.opisprograma")}</p>
                  <h4>{t("programi.subtitle2")}</h4>
                  <p>{t("osnovnem.stacetenauciti")}</p>

                  <ul className="pr-ul">
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit1")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit2")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit3")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit4")}</div>
                    </li>
                  </ul>

                  <h3>{t("programi.sadrzajPredmeta")}</h3>

                  <div
                    className="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="accordion" id="accordionExample">
                      <div className="card">
                        <div className="card-header" id="headingThree">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 0 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse0"
                              onClick={() => handleToggle(0)}
                            >
                              {t("programi.prvaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse0"
                          className={`collapse${
                            activeIndex === 0 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/osnovi-ekonomije-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/poslovna-ekonomika-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/matematicko-statisticke-metode-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/poslovna-informatika-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/menadzment-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/racunovodstvo-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb6")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/osnovi-kompanijskog-trgovinskog-prava-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb7")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/engleski-jezik-I-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb8")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingOne">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 1 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse1"
                              onClick={() => handleToggle(1)}
                            >
                              {t("programi.drugaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse1"
                          className={`collapse${
                            activeIndex === 1 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/menadzment-ljudskih-resursa-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/elektronsko-poslovanje-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/osnovi-preduzetnistva-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/marketing-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/strategijski-menadzment-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.m5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/odrzivi-razvoj-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.m6")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/upravljacko-racunovodstvo-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb7")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/engleski-jezik-II-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb8")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izborni1")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingFour">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 2 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2"
                              onClick={() => handleToggle(2)}
                            >
                              {t("programi.drugaIzborna")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse2"
                          className={`collapse${
                            activeIndex === 2 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/upravljanje-kvalitetom-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.rfb1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/menadzment-malih-srednjih-preduzeca-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.rfb2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/sociologija-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.rfb3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/logistika-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.rfb4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/poslovno-odlucivanje-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.rfb5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingTwo">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 3 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse3"
                              onClick={() => handleToggle(3)}
                            >
                              {t("programi.trecaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse3"
                          className={`collapse${
                            activeIndex === 3 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/poslovna-kultura-organizaciono-ponasanje-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("trecagodina.rfb1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/analiza-poslovanja-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("trecagodina.rfb2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/kontrola-revizija-m">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("trecagodina.rfb3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izbornimodul1")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izbornimodul2")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.strucnapraksa")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.diplomski")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h4 className="pt-40">{t("programi.moduli")}</h4>
                  <p>{t("programi.moduliHint")}</p>
                  <table className="table table-bordered mb-40">
                    <thead>
                      <tr>
                        <th>{t("programi.nazivModula")}</th>
                        <th>{t("programi.nazivPredmeta")}</th>
                        <th>{t("programi.modulSemestar")}</th>
                        <th>{t("programi.brojcasovapred")}</th>
                        <th>{t("programi.ects")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>{t("trecagodina.mmodul1")}</strong>
                        </td>
                        <td className="subject-list">
                          <Link to="/porodicni-biznis-m">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.m4")}
                              </strong>
                            </div>
                          </Link>
                          <hr />
                          <Link to="/preduzetnicki-menadzment-m">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.m5")}
                              </strong>
                            </div>
                          </Link>
                        </td>
                        <td>V</td>
                        <td>3/2</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("trecagodina.mmodul2")}</strong>
                        </td>
                        <td className="subject-list">
                          <Link to="/menadzment-bezbjednosti-m">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.m6")}
                              </strong>
                            </div>
                          </Link>
                          <hr />
                          <Link to="/sigurnost-zastita-is-m">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.m7")}
                              </strong>
                            </div>
                          </Link>
                        </td>
                        <td>V</td>
                        <td>3/2</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("trecagodina.mmodul3")}</strong>
                        </td>
                        <td className="subject-list">
                          <Link to="/poslovna-psihologija-m">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.m8")}
                              </strong>
                            </div>
                          </Link>
                          <hr />
                          <Link to="/biznis-etika-kultura-m">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.m9")}
                              </strong>
                            </div>
                          </Link>
                        </td>
                        <td>V</td>
                        <td>3/2</td>
                        <td>6</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3">
                <aside className="sidebar-widget info-column">
                  <div className="inner-column3">
                    <h3>{t("programi.osnovneinfo")}</h3>
                    <ul className="project-info clearfix">
                      <li>
                        <ProgramPricingInfo level="undergrad" t={t} />
                      </li>
                      <li>
                        <span className="icon fas fa-university" />{" "}
                        <strong>{t("programi.tipstudija")}</strong>{" "}
                        <span>{t("programi.akademske")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-calendar-alt" />{" "}
                        <strong>{t("programi.stepenstudija")}</strong>{" "}
                        <span>{t("programi.stepenosnovne")}</span>
                      </li>

                      <li>
                        <span className="icon fas fa-clock" />{" "}
                        <strong>{t("programi.trajanje")} </strong>{" "}
                        <span>{t("programi.trajanje3")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-graduation-cap" />{" "}
                        <strong>{t("programi.zvanje")}</strong>{" "}
                        <span>{t("osnovnem.zvanje")}</span>
                      </li>
                      <li>
                        <div className="slider-btn">
                          <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLSejqXir_pUuSCp0MwDJLzLoTDiT2SphgLQPO8_-5t35dxh5lw/viewform"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn ss-btn smoth-scroll"
                          >
                            {t("programi.apply")}{" "}
                            <i className="fas fa-arrow-right" />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Menadzment;
